import React from "react";
import "./HeroSection.css";
import TaglineScroller from "./TaglineScroller";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="background-container">
        {/* <div className="bg-image bg-one"></div>
        <div className="bg-image bg-two"></div> */}
      </div>
       <div className="LP-banner-conatiner">
        <img src="/assets/img/LP Banner with content.png"/>
       </div>
      
      {/* <p className="disclaimer">
        *DigitMoney is associated with  Banks & NBFCs only
      </p> */}
      {/* <TaglineScroller /> */}
    </section>
  );
};

export default HeroSection;
